/**
 * Initialises news search functionality for archive mode when the DOM is loaded
 */
document.addEventListener("DOMContentLoaded", function () {
  const newsListBlocks = document.querySelectorAll(".blk-news-list");

  newsListBlocks.forEach(function (block) {
    const isArchive = block.getAttribute("data-is-archive") === "true";

    if (isArchive) {
      initialiseSearchField(block);
    }
  });

  /**
   * Initialises search functionality for existing search field
   * @param {HTMLElement} block - The news list block element
   */
  function initialiseSearchField(block) {
    const searchField = block.querySelector(".news-search-field");

    if (!searchField) {
      return;
    }

    setupSearchHandlers(block, searchField);
  }

  /**
   * Sets up event handlers for the search field
   * @param {HTMLElement} block - The news list block element
   * @param {HTMLInputElement} searchField - The search input field
   */
  function setupSearchHandlers(block, searchField) {
    let searchTimeout;

    searchField.addEventListener("input", function () {
      clearTimeout(searchTimeout);

      searchTimeout = setTimeout(function () {
        const searchTerm = searchField.value.trim();
        performSearch(block, searchTerm);
      }, 300);
    });

    searchField.addEventListener("keydown", function (event) {
      if (event.key === "Enter") {
        event.preventDefault();
        clearTimeout(searchTimeout);
        const searchTerm = searchField.value.trim();
        performSearch(block, searchTerm);
      }
    });
  }

  /**
   * Performs the search and filters posts based on search term and active category
   * @param {HTMLElement} block - The news list block element
   * @param {string} searchTerm - The search term to filter by
   * @param {string} categoryId - Optional category ID to maintain current filter
   */
  function performSearch(block, searchTerm, categoryId = "") {
    const newsGrid = block.querySelector(".news-grid");

    if (newsGrid) {
      newsGrid.style.opacity = "0.5";
    }

    if (!categoryId) {
      const activeFilterBtn = block.querySelector(".filter-btn.active");
      categoryId = activeFilterBtn ? activeFilterBtn.getAttribute("data-category") : "";
    }
    const postsPerPage = block.getAttribute("data-posts-per-page") || "3";

    const formData = new FormData();
    formData.append("action", "search_and_filter_news_posts");
    formData.append("search_term", searchTerm);
    formData.append("category_id", categoryId);
    formData.append("posts_per_page", postsPerPage);
    formData.append(
      "nonce",
      window.ajax_object ? window.ajax_object.nonce : ""
    );

    const ajaxUrl = window.ajax_object
      ? window.ajax_object.ajax_url
      : "/wp-admin/admin-ajax.php";

    fetch(ajaxUrl, {
      method: "POST",
      body: formData,
    })
      .then((response) => {
        return response.text().then((text) => {
          console.log("Search response:", text);
          try {
            return JSON.parse(text);
          } catch (e) {
            console.error("JSON parse error:", e);
            console.error("Response text:", text);
            throw new Error("Invalid JSON response");
          }
        });
      })
      .then((data) => {
        if (data.success) {
          const swiperWrapper = block.querySelector(".swiper-wrapper");
          if (swiperWrapper) {
            swiperWrapper.innerHTML = data.data.html;
          }

          // Update pagination visibility
          const pagination = block.querySelector(".pagination");
          if (pagination) {
            if (data.data.max_num_pages <= 1) {
              pagination.style.display = "none";
            } else {
              pagination.style.display = "flex";
            }
          }
        }

        if (newsGrid) {
          newsGrid.style.opacity = "1";
        }
      })
      .catch((error) => {
        console.error("Search error:", error);

        if (newsGrid) {
          newsGrid.style.opacity = "1";
        }
      });
  }

  /**
   * Clears the search field and resets the results
   * @param {HTMLElement} block - The news list block element
   */
  function clearSearch(block) {
    const searchField = block.querySelector(".news-search-field");
    if (searchField) {
      searchField.value = "";
      performSearch(block, "");
    }
  }

  window.clearNewsSearch = clearSearch;
  window.performNewsSearch = performSearch;
});